/*

The file where all the configuration goes that you have seen previously on
your Firebase dashboard. In addition, Firebase itself will be instantiated
in this file.

*/

import firebase from 'firebase/app'
import 'firebase/auth'
import { firebaseConfig } from '../config'

// initialize firebase app
// if it isn't already initialized
if (!firebase.apps.length) {
	firebase.initializeApp(firebaseConfig)
}

// initialize the auth object
// that's the part of the Firebase API which will be used
// in the src/firebase/auth.js file and thus needs to be exported.
const auth = firebase.auth()

export {
	auth,
}


// WEBPACK FOOTER //
// ./src/common/firebase/firebase.js